import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import LanguageSwitcher from "./LanguageSwitcher";
import ThemeSwitcher from "./ThemeSwitcher";

/** Top bar of the public pages (pricing, register): brand, theme, language, sign in. */
export default function PublicHeader() {
  const { t } = useTranslation();

  return (
    <header className="mx-auto flex w-full max-w-7xl items-center justify-between gap-3 px-4 py-4 sm:px-6">
      <Link to="/pricing" className="flex items-center gap-2 text-lg font-bold text-ink">
        <img
          src={`${process.env.PUBLIC_URL}/img/puralance_mark_512.png`}
          alt=""
          width={36}
          height={32}
          className="h-8 w-auto"
        />
        Puralance
      </Link>
      <div className="flex items-center gap-2">
        <ThemeSwitcher compact />
        <LanguageSwitcher compact />
        <Link to="/login" className="btn-secondary !min-h-0 !py-1.5 text-sm">
          {t("pricing.signIn")}
        </Link>
      </div>
    </header>
  );
}
